import { errorValidation } from './utils';

let registerPhone = $('#register_phone');

/**
 * Init intlTelInput
 */
[registerPhone].forEach(phoneInput => {
	phoneInput
		.intlTelInput({
			initialCountry: 'md',
			placeholderNumberType: 'aggressive',
			utilsScript:
				'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
			separateDialCode: true,
			preferredCountries: ['md'],
			onlyCountries: ['ro', 'ua', 'md'],
		})
		.inputmask({
			mask: 'V9999999',
			definitions: {
				V: {
					validator: '^[1-9][0-9]*$',
				},
			},
		});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData'
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateRegisterPhone',
	function () {
		if (registerPhone.intlTelInput('isValidNumber')) {
			return true;
		} else {
			return false;
		}
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Register
	$("form[name='register']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'register[name]': {
				required: true,
			},
			'register[surname]': {
				required: true,
			},
			'register[email]': {
				required: true,
				email: true,
			},
			'register[phone]': {
				required: true,
				validateRegisterPhone: true,
			},
			'register[company]': {
				required: false,
			},
			'register[legal_address]': {
				required: false,
			},
			'register[tax_code]': {
				required: true,
			},
			'register[bank]': {
				required: false,
			},
			'register[password]': {
				required: true,
			},
			'register[confirm_password]': {
				required: true,
				equalTo: '#password',
			},
		},
		messages: {
			'register[name]': {
				required: window.translations.required,
			},
			'register[surname]': {
				required: window.translations.required,
			},
			'register[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'register[phone]': {
				required: window.translations.required,
			},
			'register[company]': {
				required: window.translations.required,
			},
			'register[legal_address]': {
				required: window.translations.required,
			},
			'register[tax_code]': {
				required: window.translations.required,
			},
			'register[bank]': {
				required: window.translations.required,
			},
			'register[password]': {
				required: window.translations.required,
			},
			'register[confirm_password]': {
				required: window.translations.required,
				equalTo: window.translations.equalTo,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
